import React, {useContext} from "react";
import "./SplashScreen.scss";
import StyleContext from "../../contexts/StyleContext";
import Logo from "../../assets/svg/Logo";

export default function SplashScreen() {
  const {isDark} = useContext(StyleContext);
  return (
     <div className="logo_wrapper">
      <div className={isDark? "screen": "screen lightbg"}>
        <div id='logo'>
          <Logo color="white" />
        </div>
      </div>
   </div>
  );
}
